import { useCallback } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { publicPageLoginStore } from '../usePublicPageLoginFlow'

export function useStartJoinDoesNotMeetRequirements({ spaceId }: { spaceId: string | undefined }) {
    const { setSpaceBeingJoined, setAssetModal } = publicPageLoginStore(
        useShallow((s) => ({
            setAssetModal: s.setAssetModal,
            setSpaceBeingJoined: s.setSpaceBeingJoined,
        })),
    )

    return useCallback(() => {
        if (!spaceId) {
            return
        }
        setAssetModal(true)
        setSpaceBeingJoined(spaceId)
    }, [spaceId, setSpaceBeingJoined, setAssetModal])
}
